import { Component, OnInit, Input } from '@angular/core';
import { ProductModel } from 'src/app/models/product.model';

@Component({
  selector: 'product-stats',
  templateUrl: './product-stats.component.html',
  styleUrls: ['./product-stats.component.scss'],
})
export class ProductStatsComponent implements OnInit {
  @Input()
  item:ProductModel;


  constructor() {
  }

  ngOnInit() {
  }
  
}
